module.exports = __webpack_public_path__ + "static/media/BuilderIcon.95197453.svg";